@import 'styles/variables';

.container {
  align-items: center;
  background: linear-gradient(270deg, var(--Magenta-50, #b64bf8) 0%, var(--Blue-70, #0179cf) 100%),
    var(--background, #f3f5f6);
  display: flex;
  gap: 10px;
  left: 0;
  justify-content: center;
  padding: 8px 10px;
  position: absolute;
  right: 0;
  top: 0;
  min-height: 48px;

  @media (max-width: $phoneMaxWidth) {
    min-height: 64px;
  }
}

.buttonContainer {
  background: var(--light-100);
  border-radius: 6px;
}
